import React from "react";

// reactstrap components
import {
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import DefaultNavBar from "components/Navbars/DefaultNavBar.js";
import LegalHeader from "components/Headers/LegalHeader.js";
import DarkFooter from "components/Footers/DarkFooter.js";

function PrivacyPolicyPage(props) {
  React.useEffect(() => {
    document.body.classList.add("legal-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    return function cleanup() {
      document.body.classList.remove("legal-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  return (
    <>
      <DefaultNavBar {...props} />
      <div className="wrapper">
        <LegalHeader title="Privacy Policy" />
        <div className="section">
          <Container className="legal-content">
            <Row className="justify-content-center">
              <Col md="10" lg="8">
                <p className="last-updated">Last updated: October 20, 2026</p>
                <p>
                  This Privacy Policy explains how Unlimited Transportation Corp.
                  ("Unlimited Transportation," "we," "us," or "our") collects,
                  uses, and shares information when you
                  visit unlimitedtransportation.com (the "Site"), contact us, or
                  receive text messages from us.
                </p>

                <h3>1. Information We Collect</h3>
                <ul>
                  <li>
                    <b>Information you give us:</b> When you use our contact,
                    quote request, job application, or text updates forms, we
                    collect the
                    information you provide, such as your name, company, email
                    address, phone number, mailing address, shipment details, and
                    employment and education history.
                  </li>
                  <li>
                    <b>Text messaging information:</b> For employees and job
                    applicants who opt in to our text messaging program, we
                    collect a mobile phone number and a record of their consent to
                    receive text messages.
                  </li>
                  <li>
                    <b>Information collected automatically:</b> The Site and the
                    services it uses, such as Google Analytics and Google Maps, may
                    collect information about your device and how you use the
                    Site, including your IP address, browser type, pages visited,
                    and referring website, using cookies and similar technologies.
                  </li>
                </ul>

                <h3>2. How We Use Information</h3>
                <p>We use the information we collect to:</p>
                <ul>
                  <li>respond to your questions and quote requests and provide our transportation services;</li>
                  <li>review job applications and communicate with applicants;</li>
                  <li>send employees the dispatch and delivery text messages they have agreed to receive;</li>
                  <li>understand how the Site is used and improve it; and</li>
                  <li>protect the security of the Site and comply with legal obligations.</li>
                </ul>

                <h3>3. How We Share Information</h3>
                <p>We do not sell your personal information. We may share information with:</p>
                <ul>
                  <li>
                    service providers that help us operate the Site and our
                    business, such as website hosting, form processing, and
                    analytics providers, who may use the information only to
                    provide services to us;
                  </li>
                  <li>
                    law enforcement or other parties when required by law or to
                    protect the rights, property, or safety of Unlimited
                    Transportation or others; and
                  </li>
                  <li>
                    a successor entity in connection with a merger, acquisition,
                    or sale of all or part of our business.
                  </li>
                </ul>

                <h3>4. Text Messaging (SMS)</h3>
                <p>
                  Mobile phone numbers collected for our text messaging program
                  are used only to send the dispatch and delivery messages
                  employees have agreed to receive.
                </p>
                <p>
                  <b>
                    Text messaging: No mobile information will be shared with
                    third parties or affiliates for marketing or promotional
                    purposes. Text messaging originator opt-in data and consent
                    will not be shared with any third parties. Information may be
                    shared with subcontractors that help us deliver our messaging
                    services, such as our SMS provider.
                  </b>
                </p>
                <p>
                  You can opt out at any time by replying STOP. Reply HELP for
                  help. Message frequency varies. Message and data rates may
                  apply. See our <a href="/sms-terms">SMS Terms</a> for more
                  information.
                </p>

                <h3>5. Cookies and Analytics</h3>
                <p>
                  You can set your browser to refuse cookies or to alert you when
                  cookies are being sent. Some parts of the Site may not work
                  properly without them. To opt out of Google Analytics, you can
                  install the <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google Analytics Opt-out Browser Add-on</a>.
                </p>

                <h3>6. Data Retention</h3>
                <p>
                  We keep personal information only as long as needed for the
                  purposes described in this policy or as required by law, such
                  as for employment and transportation records.
                </p>

                <h3>7. Data Security</h3>
                <p>
                  We use reasonable safeguards to protect the information we
                  collect, but no method of transmission or storage is completely
                  secure.
                </p>

                <h3>8. Your Choices</h3>
                <p>
                  You may contact us to request access to, correction of, or
                  deletion of your personal information, subject to our legal
                  obligations. You may opt out of text messages at any time by
                  replying STOP.
                </p>

                <h3>9. Children's Privacy</h3>
                <p>
                  The Site is not directed to children under 13, and we do not
                  knowingly collect personal information from children.
                </p>

                <h3>10. Changes to This Policy</h3>
                <p>
                  We may update this Privacy Policy from time to time. When we do,
                  we will post the updated policy on this page and change the
                  "Last updated" date above.
                </p>

                <h3>11. Contact Us</h3>
                <p>
                  Unlimited Transportation Corp.
                  <br />
                  3910 Groves Rd Ste A
                  <br />
                  Columbus, OH 43232
                  <br />
                  Office: <a href="tel:614-351-0400">(614) 351-0400</a>
                  <br />
                  Email: <a href="mailto:info@unlimitedtransportation.com">info@unlimitedtransportation.com</a>
                </p>
              </Col>
            </Row>
          </Container>
        </div>
        <DarkFooter />
      </div>
    </>
  );
}

export default PrivacyPolicyPage;
